let store = null;
export default function getStore() {
  if (!store) {
    // eslint-disable-next-line
    const createStore = require('./createStore').default;
    store = createStore();
  }

  return store;
}
